import React, { useContext } from 'react'
import { LogoContext } from '../../contexts/LogoContext'
import LogoSizeSlider from './LogoSizeSlider'

const LinkLogo = () => {
  const { logos, dispatch } = useContext(LogoContext)

  const linkHandler = event => {
    event.preventDefault()
    dispatch({ type: 'UPDATE_WEB_URL', url: event.target.value })
  }

  const logoSizeHandler = value => {
    dispatch({ type: 'UPDATE_WEB_WIDTH', width: value })
  }

  return (
    <div className="link-logo">
      <input
        placeholder="Paste in Logo URL"
        type="text"
        onChange={linkHandler}
        value={logos.webUrl}
        style={{ height: '21px' }}
      />
      <LogoSizeSlider
        id="web-logo-size"
        imageSrc={logos.webUrl}
        value={logos.webWidth}
        onChange={logoSizeHandler}
      />
    </div>
  )
}

export default LinkLogo
